export default "__VITE_ASSET__CjhxrJMZ__"